import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { useNavigate } from 'react-router-dom';
import * as contactActions from 'actions/contactActions';
import {
  Header,
  HeaderButtonNav,
  HeaderButton,
  HeaderTitle,
} from 'components/layout';
import * as operationsApi from 'api/operationsApi';
import VesselsListTable from './VesselsListTable';
import { Label, Row, Col, Card, CardBody } from 'reactstrap';
import Select from 'react-select';

const VesselsList = ({ actions }) => {
  const [showOverlay, setShowOverlay] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const [vessels, setVessels] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    operationsApi.getAllVessels().then((result) => {
      setVessels(result.data);
      setLoaded(true);
    });
  }, []);

  const searchVessels = (searchString) => {
    if (searchString.length >= 2) {
      operationsApi
        .getVesselSearch(searchString)
        .then((result) => result.data)
        .then((data) => setVessels(data));
      setLoaded(true);
    }
  };

  const resetView = () => {
    operationsApi.getAllVessels().then((result) => {
      setVessels(result.data);
      setLoaded(true);
    });
  };

  const options = {
    onRowClick: (row) => {
      navigate(`/vessels/edit/${row.id}`);
    },
  };

  if (!loaded) return null;

  return (
    <div>
      <Header showLogo>
        <HeaderButtonNav>
          <HeaderButton
            color="primary"
            onClick={() => navigate('/vessels/create')}
            ligature="add"
          />
        </HeaderButtonNav>
        <HeaderTitle label={'Vessels'} />
        <Card>
          <CardBody>
            <Row>
              <Col>
                <Select
                  name="Search Val"
                  placeholder="Enter Vessel to search"
                  onInputChange={searchVessels}
                />
              </Col>
              <button onClick={resetView}>Reset</button>
              <Col>
                <Label>&nbsp;</Label>
              </Col>
            </Row>
          </CardBody>
        </Card>
      </Header>
      <VesselsListTable options={options} vessels={vessels} />
    </div>
  );
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(contactActions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(VesselsList);
